import type { UpdateRdoInput } from "@/adapters/api";
import { Label } from "@/components/ui/label";
import {
	Select,
	SelectContent,
	SelectItem,
	SelectTrigger,
	SelectValue,
} from "@/components/ui/select";
import { TimePicker } from "@/components/time-picker";
import { WEATHER_OPTIONS } from "@/features/feed/utils/weather.ts";
import type { Rdo } from "../../types.ts";
import { combineReportDateTime, formatRdoTime } from "../../utils/format.ts";

const NO_WEATHER = "none";

interface SummarySectionProps {
	rdo: Rdo;
	readOnly: boolean;
	onSaveNow: (patch: UpdateRdoInput) => void;
}

export function SummarySection({ rdo, readOnly, onSaveNow }: SummarySectionProps) {
	function commitTime(field: "firstRecordAt" | "lastRecordAt", time: string) {
		const iso = combineReportDateTime(rdo.reportDate, time);
		if (iso) onSaveNow({ [field]: iso });
	}

	return (
		<section className="rdo-editor__section" aria-labelledby="rdo-summary">
			<h2 id="rdo-summary" className="rdo-editor__section-title">
				Resumo do dia
			</h2>
			<div className="rdo-editor__grid">
				<div className="rdo-editor__field">
					<Label htmlFor="rdo-weather">Clima</Label>
					<Select
						value={rdo.weatherCondition ?? NO_WEATHER}
						onValueChange={(next) =>
							onSaveNow({ weatherCondition: next === NO_WEATHER ? "" : next })
						}
						disabled={readOnly}
					>
						<SelectTrigger id="rdo-weather" className="rdo-editor__select">
							<SelectValue placeholder="Não informado" />
						</SelectTrigger>
						<SelectContent>
							<SelectItem value={NO_WEATHER}>Não informado</SelectItem>
							{WEATHER_OPTIONS.map((option) => (
								<SelectItem key={option.value} value={option.value}>
									{option.label}
								</SelectItem>
							))}
						</SelectContent>
					</Select>
				</div>
				<div className="rdo-editor__field">
					<Label htmlFor="rdo-first-record">Primeiro registro</Label>
					<TimePicker
						id="rdo-first-record"
						value={formatRdoTime(rdo.firstRecordAt)}
						disabled={readOnly}
						onChange={(next) => commitTime("firstRecordAt", next)}
					/>
				</div>
				<div className="rdo-editor__field">
					<Label htmlFor="rdo-last-record">Último registro</Label>
					<TimePicker
						id="rdo-last-record"
						value={formatRdoTime(rdo.lastRecordAt)}
						disabled={readOnly}
						onChange={(next) => commitTime("lastRecordAt", next)}
					/>
				</div>
			</div>
			<dl className="rdo-editor__facts rdo-editor__facts--counts">
				<div>
					<dt>Etapas em andamento</dt>
					<dd>{rdo.inProgressCount}</dd>
				</div>
				<div>
					<dt>Etapas concluídas</dt>
					<dd>{rdo.completedCount}</dd>
				</div>
			</dl>
		</section>
	);
}
